<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="suggestIndex"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <a href="javascript:void(0)" @click="urlTo('SuggestIndex')"><span>阳光互动</span></a> / <span>{{tabTitle}}一览</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>

        <div class="wraper">

          <div class="policy_right2" >
            <h2 class="tit tit2">{{tabTitle}}一览</h2>
         <!--   <ul >
              <li  v-for="(item,index) in dataList" :key="item.id" @click="urlTo('SuggestDetail',{detail_id:item.id,type:type})">
                <a href="javascript:void(0)"  >
                  &lt;!&ndash;style="padding-bottom: 0px;padding-top: 0px;padding-left: 0px"&ndash;&gt;
                  <dt ><h3 style="margin-top: 10px;">{{item.day}}</h3><p >{{item.time}}</p> </dt>
                  <dd >
                    <h3>{{item.title}} <span style="float: right" >
                    &lt;!&ndash;  <el-tag v-if="item.es_status!='2'"
                              type="danger"
                              effect="dark" style="width: 60px;height: 20px;line-height: 20px;margin-right: 5px;margin-top: 2px;font-size:10px;text-align: center">
                    待处理
                  </el-tag>
                       <el-tag  v-if="item.es_status=='2'"
                                effect="dark" style="width: 60px;height: 20px;line-height: 20px;margin-right: 5px;margin-top: 2px;font-size:10px;text-align: center">
                    已回复
                  </el-tag>&ndash;&gt;
                    </span ></h3>
                    <p style="font-size: 14px;margin-top: 10px;"></p>
                  </dd>
                </a>
              </li>

            </ul>-->
            <ul v-if="dataList && dataList.length>0">
              <li  v-for="(item,index) in dataList" :key="item.id" @click="urlTo('SuggestDetail',{detail_id:item.id,type:type})" >
                <a  href="javascript:void(0)">
                  <dt style="height: 90px"><h3><img src="../../../static/images/policy_sign6.png"></h3><p>{{item.time}}</p></dt>
                  <dd style="height: 90px;padding-top: 10px;">
                    <h4 style="margin-top: 10px;">{{item.title}} </h4>
                    <div style="width:100%;height:48px;    color: #888888;line-height:24px;font-size: 12px;overflow:hidden;text-overflow:ellipsis">{{item.sReamrk| ellipsis}}</div>
                  </dd>
                </a>
              </li>
            </ul>
            <div class="clear"></div>

          </div>
        </div>
        <div class="page">     <el-pagination
          layout="prev, pager, next"
          :total="pageTotal" :page-size="pageSize" @current-change="pageChange" @prev-click="prevClick" @next-click="nextClieck">
        </el-pagination>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>

  </div>
</template>

<script>
import headers from "../../components/Headers";
import fixedDiv from "../../components/FixedDiv";
import footers from "../../components/Footer";
export default {
  name: "public-index",

  components:{
    headers,fixedDiv,footers
  },
  data() {
    let _self=this;
    return {
      active: 'noticeIndex',
      width:document.body.clientWidth+'px',
      height:document.body.clientHeight+'px',
      pageNum:1,
      pageSize:8,
      pageTotal:0,
      type: 1,
      dataList:[],
      tabTitle:'',

    }
  } ,
  watch: {
    width(n,o){
      alert(n+'w')
    },
    height(n,o){
      alert(n+'h')
    },
  },
  filters: {
    ellipsis (value) {
      if (!value) return ''
      if (value.length > 120) {
        return value.slice(0,120) + '...'
      }
      return value
    }
  },

  created(){
    this.type = this.$route.query.type;
    if(this.type==1){
      this.tabTitle='投诉'
    }else if(this.type==2){
      this.tabTitle='建议'
    }else if(this.type==4){
      this.tabTitle='咨询'
    }else{
      this.tabTitle='建议'
    }
    this.initData();
  },
  methods: {
    getImg(imgId){
      var dd=this.$util.req.getshowImg(imgId);
      return dd;
    },
    prevClick(a){
      this.pageNum=this.pageNum-1;
      this.initData();
    },
    nextClieck(a){
      this.pageNum=this.pageNum+1;
      this.initData();
    },
    pageChange(a){
      this.pageNum=a
      this.initData();
    },
    initData(){
      var t=this;
      const options={pageSize:this.pageSize,pageNum:this.pageNum,type:this.type}
      this.$https.post("api/suggest/getSuggestIndexAll.do",options,response=>{
        if (response.status === 200 && response.data.code===200) {
          t.pageTotal=response.data.data.total;
          t.dataList=response.data.data.dataList;
        } else {
          // t.departOption =[];
          t.pageTotal=0;
          t.dataList=[];
        }
      })

    },
    urlTo(url,params){
      this.$router.push({path:url,query:params||{}});
    }
  }
}



</script>



// WEBPACK FOOTER //
// src/pages/suggest/SuggestList.vue